// extracted by mini-css-extract-plugin
export var avoidHeader = "main-layout-module--avoid-header--mdtaC";
export var main = "main-layout-module--main--slMPv";